<template>
  <vx-card :title="title">
    <vs-tabs :value="activeTab">
      <vs-tab label="Draft">
        <Draft></Draft>
      </vs-tab>
      <vs-tab label="Processing">
        <Processing></Processing>
      </vs-tab>
      <vs-tab label="Completed">
        <Completed></Completed>
      </vs-tab>
      <vs-tab label="Canceled">
        <Canceled></Canceled>
      </vs-tab>
    </vs-tabs>
  </vx-card>
</template>
<script>

import Draft from "./_tab/Draft.vue"
import Processing from "./_tab/Processing.vue"
import Completed from "./_tab/Completed.vue"
import Canceled from "./_tab/Canceled.vue"

export default {
  props: {
    active: {
      type: Number,
    },
  },
  components: {
    Draft,
    Processing,
    Completed,
    Canceled,
  },
  data() {
    return {
      title: "Change Batch ED",
      activeTab: this.$route.query.tab ? this.$route.query.tab : 0
    };
  },
};
</script>
